import { ActionReducerMap } from '@ngrx/store';
import * as fromAuth from './auth/reducer/auth.reducer';
import * as fromUser from './user/reducers/user.reducer';
import * as fromError from './error/reducer/error.reducer';
import * as fromNotification from './notification/reducer/notification.reducer';

export interface AppState {
  auth: fromAuth.AuthState;
  user: fromUser.UserState;
  errors: fromError.ErrorState;
  notification: fromNotification.NotificationState;
}

export const appReducer: ActionReducerMap<AppState> = {
  auth: fromAuth.authReducer,
  user: fromUser.userReducer,
  errors: fromError.errorReducer,
  notification: fromNotification.notificationReducer,
};
